import {
  reactive,
  onBeforeMount,
  computed,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';

export default function useCreateSetBannerInformatino(props) {
  const vm = getCurrentInstance().proxy;

  const form = reactive({
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    carousel: 1,
    name: null,
    description: null,
    layoutSection: null,
    carouselLayout: 1,
    status: 0,
  });

  const statusProperty = reactive({
    label_en: 'Status',
    label_th: 'Status',
    value: false,
    field_property: {
      font_size: '20px',
      mode: 2,
      value: [
        {
          item_id: 1,
          name_th: 'Offline',
          name_en: 'Offline',
          label_th: 'Inactive',
          label_en: 'Inactive',
          font_size: '20px',
          color_icon: '#AAAAAA',
          color_font: '#AAAAAA',
          value: false,
        },
        {
          item_id: 2,
          name_th: 'Online',
          name_en: 'Online',
          label_th: 'Active',
          label_en: 'Active',
          color_icon: '#00C965',
          color_font: null,
          font_size: '20px',
          value: true,
        },
      ],
    },
  });

  const carouselProperty = reactive({
    label_en: 'Carousel',
    label_th: 'Carousel',
    value: true,
    field_property: {
      font_size: '20px',
      mode: 1,
      value: [
        {
          item_id: 1,
          name_th: 'Inactive',
          name_en: 'Inactive',
          font_size: '20px',
          color_icon: '#FF0D0D',
          color_font: null,
          value: false,
        },
        {
          item_id: 2,
          name_th: 'Active',
          name_en: 'Active',
          color_icon: '#00C965',
          color_font: null,
          font_size: '20px',
          value: true,
        },
      ],
    },
  });

  const flatpickrDateConfig = reactive({
    allowInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'd-m-Y',
    minDate: null,
    onReady: function(selectedDates, dateStr, instance) {
      let el = instance.element;

      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };

      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.onfocusout = preventInput;
      el.onfocus = preventInput;
      el.style.caretColor = 'transparent';
      el.style.cursor = 'pointer';
    },
  });

  const flatpickrTimeConfig = reactive({
    allowInput: true, // prevent "readonly" prop
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i',
    time_24hr: true,
    minTime: null,
    minuteIncrement: 1,
    onReady: function(selectedDates, dateStr, instance) {
      let el = instance.element;

      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };

      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.style.caretColor = 'transparent';
      el.style.cursor = 'pointer';
    },
  });

  const initSetBannerForm = (setBanner) => {
    form.name = setBanner.set_name;
    form.carouselLayout = setBanner.layout_type;
    form.description = setBanner.description;
    form.status = setBanner.status ? 1 : 0;
    statusProperty.value = setBanner.status;
    carouselProperty.value = setBanner.carousel;
    form.validFrom.date = resolveDate(setBanner.valid_from);
    form.validThrough.date = resolveDate(setBanner.valid_through);
    form.validFrom.time = resolveTime(setBanner.valid_from);
    form.validThrough.time = resolveTime(setBanner.valid_through);
    form.layoutSection = setBanner.layout_section;
  };

  onBeforeMount(() => {
    if (props.setBanner) {
      initSetBannerForm(JSON.parse(JSON.stringify(props.setBanner)));
    }
  });

  const resolveDate = (dateInput) => {
    const date = new Date(dateInput);

    try {
      const dateStr = `${date.toLocaleString('default', {
        day: '2-digit',
      })}-${date.toLocaleString('default', {
        month: '2-digit',
      })}-${date.getFullYear()}`;

      return dateStr;
    } catch (err) {
      return '';
    }
  };

  const resolveTime = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();

      const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }`;

      return timeStr;
    } catch (err) {
      return '';
    }
  };

  const onToggleCarousel = () => {
    const carousel = vm.$refs.carouselToggle;

    form.carousel = carousel.fieldValue ? 1 : 0;
  };

  const onToggleStatus = () => {
    const status = vm.$refs.statusToggle;

    form.status = status.fieldValue ? 1 : 0;
  };

  const onOpenValidFromDatePicker = () => {
    flatpickrDateConfig.minDate = null;
  };

  const onSelectValidFromDate = () => {
    if (form.validThrough.date) {
      const validThroughDate = new Date(
        resolveDateString(form.validThrough.date)
      );

      const validFromDate = new Date(resolveDateString(form.validFrom.date));

      if (validFromDate > validThroughDate) {
        form.validThrough.date = null;
        form.validThrough.time = null;
      }
    }

    flatpickrDateConfig.minDate = form.validFrom.date;
  };

  const onOpenValidFromTimePicker = () => {
    flatpickrTimeConfig.minTime = null;
  };

  const onOpenValidThroughTimePicker = () => {
    if (form.validFrom.date == form.validThrough.date) {
      flatpickrTimeConfig.minTime = form.validFrom.time;
    }
  };

  const onSelectValidFromTimePicker = () => {
    if (
      form.validFrom.date == form.validThrough.date &&
      form.validFrom.time > form.validThrough.time
    ) {
      form.validThrough.time = null;
    }
  };

  const resolveDateString = (dateString) => {
    const date = dateString.split('-');

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]}`;

    return resolvedDate;
  };

  watch(
    () => props.setBanner,
    (newVal, oldVal) => {
      initSetBannerForm(props.setBanner);
    },
    { deep: true }
  );

  return {
    statusProperty,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    form,
    carouselProperty,
    onToggleCarousel,
    onToggleStatus,
    onOpenValidFromDatePicker,
    onSelectValidFromDate,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromTimePicker,
  };
}
